<template>

  <div class="app-messages" id="app-messages">

    <!-- <transition name="div">

      <div></div>

    </transition> -->

    <!-- <transition-group tag="ul" name="message"> -->
    <ul name="messages">

      <single-message v-for="(message) in messages" :key="message.id" :message="message"/>

    </ul>

    <!-- </transition-group> -->

  </div>

</template>

<script>
import singleMessage from './single-message';
export default{

  components: {singleMessage},
  computed: {

    messages: function(){

      return this.$store.state.messages;

    }

  }

}
</script>

<style lang="scss" scoped>
#app-messages{
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 120;
  @media (max-width: 550px){
    right: 55%;
    width: 100%;
    transform: translate(50%);
  }
}
#app-messages ul{
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
</style>
